import { Check, Eye, X } from "phosphor-react";
import React from "react";
import DocumentsApi from "~/admin/apis/documents.api";
import Badge from "~/admin/components/Badge";
import ConfirmationButton from "./ConfirmationButton";
import useLoader from "~/hooks/useLoader";
import Notifications from "~/admin/services/Notifications";

export default function DocumentsTab({ user, reload }) {
  const loader = useLoader();

  const validate = async (documentId) => {
    loader.show();
    await DocumentsApi.validateDocument(documentId).catch((e) => {
      Notifications.error("Erreur lors de la validation du document");
      return null;
    });
    Notifications.success("Document validé avec succès");
    loader.hide();
    reload();
  };
  const invalidate = async (documentId) => {
    loader.show();
    await DocumentsApi.invalidateDocument(documentId).catch((e) => {
      Notifications.error("Erreur lors de l'invalidation du document");
      return null;
    });
    Notifications.success("Document invalidé avec succès");
    loader.hide();
    reload();
  };
  return (
    <>
      {user.user.documents.map((document) => {
        return (
          <div
            key={document.id}
            className="flex flex-col items-center justify-center w-36 h-32 bg-slate-800 rounded-lg space-y-2"
          >
            <div>{document.name}</div>
            <a target="_blank" rel="noreferrer" href={document.staticFileUrl}>
              <div className="bg-slate-700 rounded-lg flex items-center px-2 py-1 hover:bg-slate-500 transition ease-in-out duration-200">
                Voir <Eye className="ml-2" />
              </div>
            </a>
            {document.isValid === null ? (
              <div className="flex justify-between items-center w-full px-8">
                <ConfirmationButton
                  confirmationTitle="Invalider le document"
                  confirmationBody={`Êtes-vous sur de vouloir invalider le document ${document.name}`}
                  color="danger"
                  data={document.id}
                  onConfirm={invalidate}
                  icon={<X />}
                />
                <ConfirmationButton
                  confirmationTitle="Valider le document"
                  confirmationBody={`Êtes-vous sur de vouloir valider le document ${document.name}`}
                  data={document.id}
                  onConfirm={validate}
                  icon={<Check />}
                />
              </div>
            ) : document.isValid ? (
              <Badge color="success">Valide</Badge>
            ) : (
              <Badge color="danger">Invalide</Badge>
            )}
          </div>
        );
      })}
    </>
  );
}
